import { FuelTypeEnum } from '../types/graphql-types';

export const TREADWELL_DEFAULT_PERSONA_NAME = 'Suburb & City';

export const TREADWELL_PRIORITY = {
  COMFORT_AND_NOISE: 'COMFORT_AND_NOISE',
  FUEL_EFFICIENCY: 'FUEL_EFFICIENCY',
  HANDLING: 'HANDLING',
  LIFE_OF_TIRE: 'LIFE_OF_TIRE',
  STOPPING_DISTANCE: 'STOPPING_DISTANCE'
};

export const TREADWELL_CUSTOM_PERSONA_NAME = 'Custom';

export const treadwellDefaults = {
  drivingStyle: TREADWELL_DEFAULT_PERSONA_NAME,
  fuelType: FuelTypeEnum.Ice,
  isWinterSearch: false,
  milesPerYear: 15,
  priority1: TREADWELL_PRIORITY.STOPPING_DISTANCE,
  priority2: TREADWELL_PRIORITY.LIFE_OF_TIRE,
  priority3: TREADWELL_PRIORITY.HANDLING,
  priority4: TREADWELL_PRIORITY.COMFORT_AND_NOISE,
  priority5: TREADWELL_PRIORITY.FUEL_EFFICIENCY,
  quantity: 4
};

export const PRODUCT_TILE_TYPES = {
  BEST_SELLER: 'BEST_SELLER',
  HIGHEST_RATED: 'HIGHEST_RATED',
  LOWEST_PRICE: 'LOWEST_PRICE',
  LOWEST_PRICE_WEB: 'LOWEST_PRICE_WEB',
  ORIGINAL_EQUIPMENT: 'ORIGINAL_EQUIPMENT',
  RECOMMENDED: 'RECOMMENDED'
};

export const TREADWELL_FORM_EVENTS = {
  CLEAR_TREADWELL_FORM: 'CLEAR_TREADWELL_FORM',
  INITIALIZE_DRIVER_LOCATION_FORM: 'INITIALIZE_DRIVER_LOCATION_FORM',
  INITIALIZE_DRIVER_TYPE_FORM: 'INITIALIZE_DRIVER_TYPE_FORM',
  INITIALIZE_DRIVING_PREFERENCES_FORM: 'INITIALIZE_DRIVING_PREFERENCES_FORM'
};
